import { render } from "./WebsiteEditorPage.vue?vue&type=template&id=bad2b75a&scoped=true"
import script from "./WebsiteEditorPage.vue?vue&type=script&lang=js"
export * from "./WebsiteEditorPage.vue?vue&type=script&lang=js"

import "./WebsiteEditorPage.vue?vue&type=style&index=0&id=bad2b75a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad2b75a"]])

export default __exports__